import useEntities from 'new/state/entities/repository/useEntities';

interface UseUncategorizedPipelinesEntitiesReturn {
  entities: any;
  sources: any;
  vendors: any;
  flowNodes: any;
}

export function useUncategorizedPipelinesEntities(): UseUncategorizedPipelinesEntitiesReturn {
  const { data: entities } = useEntities();
  const { data: sources } = useEntities('sources');
  const { data: vendors } = useEntities('vendors');
  const { data: flowNodes } = useEntities('flowNodes');

  return {
    entities,
    sources,
    vendors,
    flowNodes,
  };
}
